// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../images/nav-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.modal-open {
  padding-right: 0 !important;
}

.buysinglevideo_modal .modal-content {
  overflow: hidden;
  border: none;
  border-radius: 10px;
}
.buysinglevideo_modal .modal-content .modal-header {
  position: relative;
}
.buysinglevideo_modal .modal-content .modal-header .buysinglevideomodal-img {
  left: 0;
  top: 0;
  width: 100%;
  height: 130px;
  content: "";
  position: absolute;
  backdrop-filter: blur(17px);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  z-index: 1;
}
.buysinglevideo_modal .modal-content .modal-header .title-content {
  color: #ffffff;
  position: relative;
  z-index: 3;
}
.buysinglevideo_modal .modal-content .modal-body .img-block {
  position: relative;
  z-index: 2;
}
.buysinglevideo_modal .modal-content .modal-body .card {
  background: transparent;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/learn_practice/videos/singlevideo/_buysinglevediomodal.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;AACJ;;AAEA;EACI,gBAAA;EACA,YAAA;EACA,mBAAA;AACJ;AACI;EACI,kBAAA;AACR;AACQ;EACI,OAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,mDAAA;EACA,sBAAA;EACA,+BAAA;EACA,4BAAA;EACA,UAAA;AACZ;AAEQ;EACI,cAAA;EACA,kBAAA;EACA,UAAA;AAAZ;AAKQ;EACI,kBAAA;EACA,UAAA;AAHZ;AAMQ;EACI,uBAAA;EACA,UAAA;AAJZ","sourcesContent":["body.modal-open {\n    padding-right: 0 !important;\n}\n\n.buysinglevideo_modal .modal-content {\n    overflow: hidden;\n    border: none;\n    border-radius: 10px;\n\n    .modal-header {\n        position: relative;\n\n        .buysinglevideomodal-img {\n            left: 0;\n            top: 0;\n            width: 100%;\n            height: 130px;\n            content: '';\n            position: absolute;\n            backdrop-filter: blur(17px);\n            background: url('../../../../../images/nav-bg.png');\n            background-size: cover;\n            background-position: top center;\n            background-repeat: no-repeat;\n            z-index: 1;\n        }\n\n        .title-content {\n            color: #ffffff;\n            position: relative;\n            z-index: 3;\n        }\n    }\n\n    .modal-body {\n        .img-block {\n            position: relative;\n            z-index: 2;\n        }\n\n        .card {\n            background: transparent;\n            z-index: 2;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
